import form from './form';

const wizardHeader = { form };

export default wizardHeader;
